import type { ReactNode } from "react";
import { useTranslations } from "use-intl";
import { CollapsibleCard } from "../../CollapsibleCard";

type Props = {
  content: ReactNode;
};

export function TermsAndConditionsCard({ content }: Props) {
  const t = useTranslations();

  return (
    <CollapsibleCard
      title={t("trips.termsAndConditions.title")}
      expandedByDefault={false}
    >
      <div className="text-sm text-text-primary">{content}</div>
    </CollapsibleCard>
  );
}
